export default {
  notSpecified: "Not specified",
  notAssigned: "not assigned",
  notYetAssigned: "Not Yet Assigned",
  globalErrorMessageHeader: "Error",
  globalErrorMessage:
    "An error has been occurred during your request and the IT support has been informed. We will resolve this issue as soon as possible and are sorry for the inconvenience.",
  addModelName: "add model name",
  resetPassword: "You will be redirected to an external website to reset your password. Do you want to proceed?",
};
